import { z } from "zod"

import {
  fieldProjectionV9Schema,
  fieldVisitProjectionV9Schema,
} from "./field-projection-v9.js"
import { fieldVisitTimeProjectionV1Schema } from "./field-projection-v1.js"

export const fieldVisitTimeProjectionV10Schema = fieldVisitTimeProjectionV1Schema.extend({
  activeStartedAt: z.iso.datetime({ offset: true }).nullable().default(null),
}).strict()

export const fieldVisitProjectionV10Schema = z.object({
  ...fieldVisitProjectionV9Schema.shape,
  workedSeconds: z.number().int().nonnegative().safe().default(0),
}).strict().superRefine((visit, context) => {
  const { workedSeconds: _workedSeconds, ...legacy } = visit
  const parsed = fieldVisitProjectionV9Schema.safeParse(legacy)
  if (!parsed.success) {
    for (const issue of parsed.error.issues) {
      context.addIssue({ code: "custom", message: issue.message, path: issue.path })
    }
  }
})

export const fieldProjectionV10Schema = z.object({
  ...fieldProjectionV9Schema.shape,
  responseVersion: z.literal(10),
  visitTime: fieldVisitTimeProjectionV10Schema.nullable(),
  visits: z.array(fieldVisitProjectionV10Schema).max(100),
}).strict().superRefine((projection, context) => {
  const legacyVisitTime = projection.visitTime
    ? (() => {
        const { activeStartedAt: _activeStartedAt, ...legacy } = projection.visitTime
        return legacy
      })()
    : null
  const candidate = {
    ...projection,
    responseVersion: 9 as const,
    visitTime: legacyVisitTime,
    visits: projection.visits.map((visit) => {
      const { workedSeconds: _workedSeconds, ...legacy } = visit
      return legacy
    }),
  }
  const parsed = fieldProjectionV9Schema.safeParse(candidate)
  if (!parsed.success) {
    for (const issue of parsed.error.issues) {
      context.addIssue({ code: "custom", message: issue.message, path: issue.path })
    }
  }
})

export type FieldProjectionV10 = z.infer<typeof fieldProjectionV10Schema>
export type FieldVisitProjectionV10 = z.infer<typeof fieldVisitProjectionV10Schema>
